module.exports = __webpack_public_path__ + "img/AlarmOffOutlined.2f596e28.svg";